<template>
    <div>
        <b-button class="mb-2" variant="success" @click="addData">{{ $t('addData') }}</b-button>
        <b-button class="mb-2 ml-2" variant="danger" @click="dropResource">{{ $t('drop') }}</b-button>
        <b-dropdown :text="env" class="ml-2 mb-2">
            <b-dropdown-item @click="changeEnv('live')">{{ $t('live') }}</b-dropdown-item>
            <b-dropdown-item @click="changeEnv('dev')">{{ $t('dev') }}</b-dropdown-item>
        </b-dropdown>
        <b-row class="mb-2">
            <b-col cols="10">
                <b-input-group>
                    <b-input v-model="filterField" :placeholder="$t('filters')" />
                    <b-input-group-append>
                        <b-button @click="fetchData" variant="success">{{$t('find')}}</b-button>    
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col cols="2" align-self="stretch">
                <b-input-group>
                    <b-input-group-prepend>
                        <b-button @click="prevPage" :disabled="page < 2" variant="primary"> <b-icon icon="arrow-left-short" /> </b-button>
                    </b-input-group-prepend>
                    <b-button variant="dark">{{ page }}</b-button>
                    <b-input-group-append>
                        <b-button @click="nextPage" :disabled="page >= pages" variant="primary"> <b-icon icon="arrow-right-short" /> </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>
        <b-skeleton v-if="!resource" animation="throb" height="200px"></b-skeleton>
        <b-card v-for="data in resource.items" :key="data._id" @click="editData(data._id, data)" v-else>
            <code-editor :value="getValue(data)" :withButton="false" :disabled="!isEditing(data._id)" @input="(e) => updateData(data._id, e)"/>
            <b-card-footer v-if="isEditing(data._id)">
                <b-button class="m-2" variant="success" @click="saveData(data._id)">{{ $t('edit') }}</b-button>
                <b-button class="m-2" variant="danger" @click="removeData(data._id)">{{ $t('delete') }}</b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>
<script>
import CodeEditor from "@/components/form/Editor/Code"

export default {
    name: 'Resource',
    components: {
        CodeEditor
    },
    data: function() {
        return {
            resource: null,
            editingIds: [],
            resourceData: {},
            isLive: false,
            env: this.$store.getters.getCurrentEnv,
            filterField: null,
            limit: 12,
            page: 1
        }
    },
    computed: {
        filters() {
            return JSON.parse(this.filterField)
        },

        pages() {
            if (this.resource) return this.resource.pages

            return 1
        }
    },
    methods: {
        getValue(d) {
            return JSON.stringify(d || {}, null, 2)
        },

        editData(id, data) {
            if (!this.isEditing(id))
                this.editingIds.push(id)
        },

        isEditing(id) {
            return this.editingIds.indexOf(id) !== -1
        },

        updateData(id, data) {
            this.resourceData[id] = data
        },

        saveData(id) {
            if (this.resourceData[id] === undefined) {
                return;
            }

            let popup = this.$loadingPopup();

            this.$http.put("/v3/system/thunder", {
                type: this.$route.params.name,
                filters: {
                    _id: id
                },
                data: JSON.parse(this.resourceData[id]),
                flag: "Upsert"
            },{
                headers: {
                    'X-Project-Env': this.env
                }
            }).then(resp => {
                
            }).catch(err => {
                this.$debugLog(err)
                this.$bvModal.msgBoxOk(err.response.data.message)
            }).finally(() => {
                popup.hide()
            })
        },

        removeData(id) {
            this.$bvModal.msgBoxConfirm(`${this.$t('areYouSure')}?`).then(resp => {
                if (resp) {
                    this.$http.put("/v3/system/thunder", {
                        type: this.$route.params.name,
                        filters: {
                            _id: id
                        },
                        flag: "Delete"
                    },{
                        headers: {
                            'X-Project-Env': this.env
                        }
                    }).then(resp => {
                        this.resource.items = this.resource.items.filter(d => {
                            return d._id != id
                        })
                    }).catch(err => {
                        this.$debugLog(err)
                        if (err.response) {
                            this.$bvToast.toast(err.response.data.message, {
                                variant: 'danger',
                                title: this.$t('error')
                            })

                            return 
                        }

                        this.$bvToast.toast(this.$t('unexpectedError'), {
                            variant: 'danger',
                            title: this.$t('error')
                        })
                    })
                }
            })
        },

        addData() {
            let popup = this.$loadingPopup(`${this.$t('addingResource')}...`);

            this.$thunder(this.env).write({
                type: this.$route.params.name,
                filters: {
                    incrementId: this.resource.total
                },
                data: {},
                flag: "InsertOne"
            }).then(resp => {
                this.fetchData()
            }).catch(err => {
                this.$debugLog(err)
                if (err.response) {
                    this.$bvToast.toast(err.response.data.message, {
                        variant: 'danger',
                        title: this.$t('error')
                    })

                    return 
                }

                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger',
                    title: this.$t('error')
                })
            }).finally(() => {
                popup.hide()
            })
        },

        async dropResource() {
            const confirm = await this.$deleteConfirmationPrompt()
            if (!confirm) return

            let popup = this.$loadingPopup(`${this.$t('removingResource')}...`);

            this.$http.delete(`/v3/system/thunder/${this.$route.params.name}`)
            .then(() => {
                this.$router.push("/admin/thunder")
            }).catch(err => {
                this.$debugLog(err)
                this.$bvModal.msgBoxOk(`${this.$t('failedToDrop')}.`)
            }).finally(() => {
                popup.hide()
            })

        },

        fetchData() {
            this.resource = null

            this.$thunder(this.env).read({
                type: this.$route.params.name,
                filters: this.filters,
                flag: "Paginate",
                options: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                    sort: [
                        {
                            key: "incrementId",
                            value: -1
                        }
                    ]
                }
            }).then(data => {
                this.resource = data || []
            }).catch(err => {
                this.$debugLog(err)
                this.$bvToast.toast(this.$t('failedToFetchResource'), {
                    variant: 'danger',
                    title: this.$t('error')
                }) 
            })
        },

        changeEnv(env) {
            this.env = env
            this.fetchData()
        },

        prevPage() {
            this.page--
            if (this.page < 1) {
                this.page = 1
            }

            this.fetchData()
        },

        nextPage() {
            this.page++
            this.fetchData()
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>
